import { createSelector } from '@reduxjs/toolkit';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'data';
import { TemplateId } from 'data/templates/api';
import { ProjectTemplateSpaceSetupStage } from '../types';
import { useActiveTemplateId } from './use-active-project-template';

const hasSetupSpacesInTemplate = () =>
  createSelector(
    (state: RootState) => state.templates.project,
    (_, templateId: TemplateId) => templateId,
    (project, templateId): ProjectTemplateSpaceSetupStage =>
      project.data[templateId].spaceSetup,
  );

export const useHasSetupSpacesInTemplate =
  (): ProjectTemplateSpaceSetupStage => {
    const templateId = useActiveTemplateId();
    const hasSetupSpacesInTemplateObject = useMemo(
      hasSetupSpacesInTemplate,
      [],
    );

    return useSelector((state: RootState) =>
      hasSetupSpacesInTemplateObject(state, templateId),
    );
  };
